import { useEffect, useState } from 'react'
import SessionService from '../services/session'
import { sessionStorage } from '../state/utils/storage'

const useProspectGuard = ({ disableGuard, redirectTo } = {}) => {
	const [isVisibleModalAuth, setIsVisibleModalAuth] = useState(false)
	const [userInfo, setUserInfo] = useState()

	const handleValidation = () => {
		const prospectSession = sessionStorage.getItem('PROSPECT_TEMP_USER')
		const tokenId = SessionService.getIdTokenData()
		if (!prospectSession && !tokenId) {
			setIsVisibleModalAuth(true)
		} else {
			setUserInfo(prospectSession)
			setIsVisibleModalAuth(false)
		}
	}

	const onHideModal = () => {
		const prospectSession = sessionStorage.getItem('PROSPECT_TEMP_USER')
		const tokenId = SessionService.getIdTokenData()
		if (!prospectSession && !tokenId) {
			window.location.href = redirectTo
		} else {
			setIsVisibleModalAuth(false)
		}
	}

	const onSuccesRegister = data => {
		sessionStorage.setItem('PROSPECT_TEMP_USER', data)
		setUserInfo(data)
		setIsVisibleModalAuth(false)
	}

	useEffect(() => {
		if (!disableGuard) {
			handleValidation()
		}
	}, [])

	return { isVisibleModalAuth, onHideModal, onSuccesRegister, userInfo }
}

export default useProspectGuard
